import $api from "@/frontend/shared/api/axios";

export async function getCheckDomain({ domain }: { domain: string }) {
  const response = await $api.get(`/companies/check-domain?domain=${domain}`);
  return response.data.data;
}
